function closeSearch() {
    unfixBody();
    $('.js-search').removeClass('open');
    $('.js-search-input').blur();
    $('.js-results-container').fadeOut();
}

$(function(){
    $('.js-open-search').on('click', function(){
        if ($('.js-search').is('.open')) {
            closeSearch();
        } else {
            $('.js-search').addClass('open');
            $('.js-search input').val('').focus();
            fixBody();
        }
    });

    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            e.stopPropagation();
            if ($('.js-search').is('.open')) {
                closeSearch();
            }
        }
    });

    $('.js-close-search').on('click', function(){
        closeSearch();
    });


    // AJAX

    $('.js-search-input').on('input', function(){
        keyword = $(this).val();
        if (keyword.length === 0) {
            $('.js-results').html('');
            $('.js-results-container').fadeOut();
        } else {
            jQuery.post(
                ajaxurl,
                {
                    'action': 'search',
                    'keyword': keyword
                },
                function(response) {
                    $('.js-results-container').fadeIn();
                    $('.js-results').html(response);
                }
            );
        }
    });
});
